import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Pencil1Icon } from '@radix-ui/react-icons';
import { ElevatedButton } from '@producer/ui-kit';

import { DropdownMenu } from '../../../components/modals/dropdown-menu/DropdownMenu';
import { ScreenHeader } from '../../projects/components/screen-header';
import { RenameStepModal } from '../../process/components/rename-step.modal';

import type { Step } from '../../../app/entities/step';

type TeamHeaderProps = {
  step: Step;

  /**
   * `step.info?.teamId` is no longer written by anything — departments are a property now, not
   * entities — so the step's validatability moves onto whether the project actually has crew.
   */
  canValidateStep: boolean;

  /** Creates a crew member from the step header, the way `Resources > Crew` offers it. */
  onCreate: () => void;
};

export const TeamHeader: React.FC<TeamHeaderProps> = observer(
  ({ step, canValidateStep, onCreate }) => {
    const [isRenameModalOpen, setIsRenameModalOpen] = useState(false);

    const items: React.ComponentProps<typeof DropdownMenu>['items'] = [
      {
        title: 'Rename step',
        icon: <Pencil1Icon />,
        onSelect: () => setIsRenameModalOpen(true),
      },
    ];

    return (
      <>
        <ScreenHeader
          stepId={step._id}
          title={step.name}
          dueDate={step.dueDate}
          startDate={step.startDate}
          handleUpdateTimeFrame={(values) => step.update(values)}
          menu={<DropdownMenu items={items} size={'large'} />}
          actions={[
            <ElevatedButton key="add-crew-member" text="Add crew member" onClick={onCreate} />,
          ]}
          canValidateStep={canValidateStep}
        />

        {isRenameModalOpen && (
          <RenameStepModal step={step} onCancel={() => setIsRenameModalOpen(false)} />
        )}
      </>
    );
  },
);
